import { combineReducers } from "redux";
import registerReducer from "./Slices/registerSlice";
import utilityReducer from "./Slices/utilitySlice";
import loginReducer from "./Slices/loginSlice";
import resetPasswordReducer from "./Slices/resetPasswordSlice";
import adminLoginReducer from "./Slices/adminLoginSlice";
import businessReducer from "./Slices/businessSlice";
import venueReducer from "./Slices/venueSlice";
import venueImageReducer from "./Slices/venueImageSlice";
import enquiryReducer from "./Slices/enquirySlice";
import userReducer from "./Slices/userSlice";
import vendorReducer from "./Slices/vendorSlice";
import vendorProfileReducer from "./Slices/vendorProfileSlice";
import mailReducer from "./Slices/mailSlice";
import reviewReducer from "./Slices/reviewSlice";
import realWeddingReducer from "./Slices/realWeddingSlice";

const reducers = combineReducers({
  registerReducer,
  utilityReducer,
  loginReducer,
  resetPasswordReducer,
  adminLoginReducer,
  businessReducer,
  venueReducer,
  venueImageReducer,
  enquiryReducer,
  userReducer,
  vendorReducer,
  vendorProfileReducer,
  mailReducer,
  reviewReducer,
  realWeddingReducer,
});

export default reducers;